<div
  [ngClass]="{ 'ms-4': isLeaf(providedData) }"
  class="tree-node"
  [hidden]="isRoot(providedData)"
>
  @if (providedData.children.length) {
    <button
      type="button"
      class="fa fa-lg fa-fw caret-button"
      [ngClass]="getOrientedCaretClass()"
      (click)="changeExpanded()"
    ></button>
  }
  <label class="checkbox-label">
    <input
      class="checkbox-input"
      type="checkbox"
      [checked]="providedData.selected"
      [indeterminate]="isPartiallySelected(providedData)"
      [disabled]="!providedData.selectable"
      (change)="changeSelected($event)"
    />
    {{ providedData.translationKey | translate }}
  </label>
  @if (providedData.namespace === ExternalNodeNamespaces.ExternalGroup) {
    <span
      type="button"
      class="fa fa-plus plus-icon"
      (click)="attachWmsToTreeMap()"
    ></span>
  }
  @if (providedData.namespace === ExternalNodeNamespaces.ExternalWms) {
    <span
      type="button"
      class="fa fa-minus minus-icon"
      (click)="detachWmsFromTreeMap()"
    ></span>
  }
</div>
<div [hidden]="!providedData.expanded">
  <ul class="tree-node-children" [ngClass]="{ 'ms-3': !isRoot(providedData) }">
    @for (childNode of providedData.children; track childNode.id) {
      <li>
        <gk-tree-node
          [providedData]="childNode"
          (dispatch)="handleChildChange($event)"
          (dispatchMapAction)="handleAddWms($event)"
        >
        </gk-tree-node>
      </li>
    }
  </ul>
</div>
